import React, { useState, useContext, useCallback } from 'react';
import { TmoCard } from '@tmobile/tmo-bps-syncup-web-component-lib';

import platformService from '../../services/platformService';
import Fetcher from '../Fetcher';
import OncallSupportGroup from './OncallSupportGroup';
import SyncUpProductContext from '../../context/SyncUpProductContext';

import style from './SupportGroupsGrid.module.css';

function OnCallSupport() {
  const [contacts, setContacts] = useState();
  const syncUpProductContext = useContext(SyncUpProductContext);

  const actionCallback = useCallback(
    () =>
      platformService.getOnCallSupportGroup({
        syncUpAppName: syncUpProductContext.syncUpAppName
      }),
    [syncUpProductContext.syncUpAppName]
  );

  return (
    <TmoCard className={style.container}>
      <Fetcher
        action={actionCallback}
        onLoad={setContacts}
        render={() =>
          contacts?.count > 0 ? (
            <>
              {contacts.data.map((contact, index) => (
                <OncallSupportGroup key={index} data={contact} />
              ))}
            </>
          ) : (
            <span className={style.message}>
              <span>0</span> Contacts
            </span>
          )
        }
      />
    </TmoCard>
  );
}

export default OnCallSupport;
